import { ScheduleContainer, ScheduleItem, Separator } from "./styles";

const formatDayDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) return dateString;

  return date.toLocaleDateString("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric"
  });
};

const formatTimeRange = (startTime, endTime) => {
  if (startTime && endTime) {
    return `${startTime.slice(0, 5)}–${endTime.slice(0, 5)}`;
  }
  if (startTime) {
    return startTime.slice(0, 5);
  }
  if (endTime) {
    return endTime.slice(0, 5);
  }
  return "";
};

const Schedule = ({ days = [], error }) => {
  const hasDays = !error && days.length > 0;

  return (
    <ScheduleContainer>
      {hasDays && <h2>{"Today's Highlights"}</h2>}

      {error && (
        <div className="text-container">
          <p>{"We were unable to load your program at this time."}</p>
          <p>{error}</p>
        </div>
      )}

      {!error && !hasDays && (
        <div className="text-container">
          <p>
            {
              "Your detailed program will appear here once it has been assigned to your device."
            }
          </p>
        </div>
      )}

      {hasDays && (
        <>
          {days.map((day) => (
            <ScheduleItem key={day.id}>
              <div className="schedule-list">
                <p>{formatDayDate(day.date)}</p>
                {day.title && <p className="bold">{day.title}</p>}
                {day.subtitle && <p>{day.subtitle}</p>}
                <Separator />
                {day.agendaItems?.map((item) => {
                  const time = formatTimeRange(item.startTime, item.endTime);
                  return (
                    <p className="schedule-item" key={item.id}>
                      <span className="time">{time}</span>
                      {time ? " - " : ""}
                      <span className={!time ? "time" : ""}>{item.title}</span>
                      {item.description && (
                        <span>{` - ${item.description}`}</span>
                      )}
                    </p>
                  );
                })}
              </div>
            </ScheduleItem>
          ))}
          <div className="end-lines">
            <div className="line" />
            <div className="line" />
          </div>
        </>
      )}
    </ScheduleContainer>
  );
};

export default Schedule;

